import { AdminRepo, AdminApi } from "common/helpers/admin-page-class"
import { UsersApi } from "common/api"
import { filterUsers, sortUsers } from "./utils"

const organizer = {
  filter: filterUsers,
  sort: sortUsers
}
const repo = new AdminRepo(organizer)

const http = {
  get: UsersApi.get,
  create: UsersApi.create,
  update: UsersApi.update,
  remove: UsersApi.remove
}
const api = new AdminApi(http, repo)

const methods = {
  get: api.get.bind(api),
  create: api.create.bind(api),
  update: api.update.bind(api),
  remove: api.remove.bind(api)
}

export { methods as UsersApi }
